import { h, Component } from "preact";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import $ti from '../ti.js'

import * as _ from "../components/index.js";

class Marathon extends Component {
  constructor(props) {
    super(props);
    let templates = Globals.Templates();

    let marathonTemplates = {}
    let tmp = 0;
    for(let i = 1; i <= 10; i++){
      marathonTemplates[i] = {
        "number": i,
        "title": "# "+i,
        "status": "1",
        "ord": i,
        questions: [],
      }
      for(let z = 0; z < 4; z++){
        tmp = ((i-1) * 4) + z;
        marathonTemplates[i]['questions'] = [...marathonTemplates[i]['questions'],...templates[tmp].questions];
      }
    }
    this.state = {
      templatesTotal: marathonTemplates ? Object.keys(marathonTemplates).length : 0,
      data: marathonTemplates
    };
  }

  componentDidMount() {

  }

  render() {
    let data = this.state.data;
    return (
      <>
        <_.Header title="Марафон"/>
        
        <section class="menu">
          {data ? Object.keys(data).map((key)=>(
              <_.marathonTemplate id={parseInt(key)} data={data[key]}/>
          )) : null}

        </section>
      </>
    );
  }
}

export default GlobState.connect(Marathon, Globals)